// @flow

export const INITIAL_ITEMS_COUNT = 20
export const NUMBER_OF_FILES_SHOWN = 2
export const HIDE_SUCCESS_MODAL_KEY = 'hide_success_modal'
export const FROM_CREATE = 'from_create'
export const MASS_CREATED = 'mass_created'
